module.exports = __webpack_public_path__ + "static/img/12deyi.679a4222.gif";